import React from "react";
import "./recognition.scss";

export interface IRecognition {
  title: string;
  text: string;
}

const Recognition = (props: IRecognition) => {
  const { title, text } = props;
  return (
    <div className="recognition">
      <h2>{title}</h2>
      <hr />
      <p>{text}</p>
    </div>
  );
};

export default Recognition;
